module.exports = "/images/vendor/flag-icon-css/flags/1x1/ck.svg?22bf8119f315420569c9699f027cfd03";